export const FiveStarsIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 74 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M51.5 34L53.1839 39.1824H58.6329L54.2245 42.3853L55.9084 47.5676L51.5 44.3647L47.0916 47.5676L48.7755 42.3853L44.3671 39.1824H49.8161L51.5 34Z"
        fill="currentColor"
      />
      <path
        d="M21.5 34L23.1839 39.1824H28.6329L24.2245 42.3853L25.9084 47.5676L21.5 44.3647L17.0916 47.5676L18.7755 42.3853L14.3671 39.1824H19.8161L21.5 34Z"
        fill="currentColor"
      />
      <path
        d="M21.5 4L23.1839 9.18237H28.6329L24.2245 12.3853L25.9084 17.5676L21.5 14.3647L17.0916 17.5676L18.7755 12.3853L14.3671 9.18237H19.8161L21.5 4Z"
        fill="currentColor"
      />
      <path
        d="M36.5 19L38.1839 24.1824H43.6329L39.2245 27.3853L40.9084 32.5676L36.5 29.3647L32.0916 32.5676L33.7755 27.3853L29.3671 24.1824H34.8161L36.5 19Z"
        fill="currentColor"
      />
      <path
        d="M51.5 4L53.1839 9.18237H58.6329L54.2245 12.3853L55.9084 17.5676L51.5 14.3647L47.0916 17.5676L48.7755 12.3853L44.3671 9.18237H49.8161L51.5 4Z"
        fill="currentColor"
      />
    </svg>
  );
};
